import {useEffect, useRef} from 'react';


export default function useFrame(callback=()=>{}, props = []){
	// Use useRef for mutable variables that we want to persist
	// without triggering a re-render on their change
	const requestRef = useRef(0);
	const previousTimeRef = useRef(0);

	useEffect(() => {
		const animate = (time) => {
			if (previousTimeRef.current !== undefined) {
				const deltaTime = time - previousTimeRef.current;
				callback(time / 1000, deltaTime / 1000); //seconds
			}
			previousTimeRef.current = time;
			requestRef.current = requestAnimationFrame(animate);
		};

		requestRef.current = requestAnimationFrame(animate);
		return () => cancelAnimationFrame(requestRef.current);
	}, props);
}
